import { useState, useEffect } from 'react';
import axiosInstance from '../../helpers/axios';
import DatePicker from "react-multi-date-picker";
import calender from "../../assets/images/calender.png";
import download from "../../assets/images/download.png";
import moment from 'moment';
import { Input } from "reactstrap";
import search from "../../assets/images/search.png";
import { userActions } from '../../actions/user.actions';
import { useDispatch, useSelector } from "react-redux";
import { TablePagination } from "@mui/material";
import AiCollectionOptimizer from "./AiCollectionOptimizer/AiCollectionOptimizer";




export default function CollectionPerformance() {

  const [TableData, setTableData] = useState()
  const [data, setData] = useState()
  const [startDate,setStartDateFrom] = useState()
  const [endDate,setEndDateTo] = useState()
  const [MipData, setMipData] = useState()
  const [selectedName,setSelectedName] = useState()
  // const [infotableData, setInfoTableData] = useState()
  const [ infoData, setInfoData] = useState([])
  const [loanid, setLoanid] = useState(null);
  const [bucketStatus,setBucketStatus] =useState(null);
  const [tableVisible, setTableVisible] = useState(true);
  const dispatch = useDispatch();

  const clearFilter =()=>{
    setSelectedName('');
    setLoanid('');
    setBucketStatus('');
    setStartDateFrom('');
    setEndDateTo('');
    setTableVisible(false); 

  }

  const productTypeSelected = useSelector((state) => state.ProductTypeFilter.selectedProductType);


  const user = null;


  useEffect(() => {
    clearFilter()
    // Get the start of the current month and the current date
    const startDateFrom = moment().startOf('month');
    const endDateTo = moment();

    // Format the dates to the desired format
    const formattedStartDate = startDateFrom.format('YYYY-MM-DD');
    const formattedEndDate = endDateTo.format('YYYY-MM-DD');

    let queryParams = {};


    if (formattedStartDate && formattedEndDate) {
      queryParams.startDate = formattedStartDate;
      queryParams.endDate = formattedEndDate;
    }
    if (productTypeSelected && productTypeSelected !== "all") {
      queryParams.loanType = Number(productTypeSelected);
    }

    axiosInstance.get('/analytics/collection-performance', {
      headers: {
      },
      params: queryParams // Pass the query params here
    })
    .then((res) => {
      setData(res?.data?.emiDetails?.overdueamount);
    })
    .catch((error) => {
    });

 
    axiosInstance.get('/analytics/get-count-of-mip', {
      params: queryParams,
      headers: {
      }
    })
    .then((res) => {   
      setMipData(res?.data?.data.count)
    })
    .catch((error) => {
    });


  
  }, [productTypeSelected]); 


  const fetchingData = ()=>{
   
    let queryParams = {}
    if(startDate && endDate){
      const formattedStartDate = moment(startDate, 'DD MMM YYYY').format('YYYY-MM-DD');
      const formattedEndDate = moment(endDate, 'DD MMM YYYY').format('YYYY-MM-DD') ;

    queryParams.startDate = formattedStartDate;
    queryParams.endDate = formattedEndDate;
    }
    if (productTypeSelected && productTypeSelected !== "all") {
      queryParams.loanType = Number(productTypeSelected);
    }
    axiosInstance.get('/analytics/collection-performance', {
      params: queryParams,
      headers: {
      },
    })
    .then((res) => {

      setTableData(res?.data?.emiDetails?.overdueamount);
     
    })
    .catch((error) => {
      alert(error?.response?.data?.message)
      console.error("Error fetching filtered data:", error);
    });
  
    let queryParamsBucket={}
    if (selectedName === "Grand Total") {
      setTableVisible(true);
     queryParamsBucket.bucketwise = null;
   } else {
   queryParamsBucket.bucketwise = selectedName;
   }
   
   
   let queryParamsLoan={}
   if(loanid){
    setTableVisible(true); 
     queryParamsLoan.loanid=loanid
    }
    if(bucketStatus){
      setTableVisible(true); 
     queryParamsLoan.Status=bucketStatus
    }
   
     axiosInstance.get ('/analytics/collection-performance-loans',{
       headers: {
       },
       params: {startDate:queryParams.startDate,endDate:queryParams.endDate,bucketwise:queryParamsBucket.bucketwise,loanid:queryParamsLoan.loanid,Status:queryParamsLoan.Status}
    
     })
     .then((res) => {   
       setInfoData(res?.data?.emiDetails)
     })
     .catch((error) => {
     });
   
   }

   const tableBucketClicked=(selectedName)=>{
    setTableVisible(true); 
    const startDateFrom = moment().startOf('month');
    const endDateTo = moment();

    // Format the dates to the desired format
    const formattedStartDate = startDateFrom.format('YYYY-MM-DD');
    const formattedEndDate = endDateTo.format('YYYY-MM-DD');

    let queryParams = {};
  
    if(startDate && endDate){
      const formattedStartDate = moment(startDate, 'DD MMM YYYY').format('YYYY-MM-DD');
      const formattedEndDate = moment(endDate, 'DD MMM YYYY').format('YYYY-MM-DD') ;

    queryParams.startDate = formattedStartDate;
    queryParams.endDate = formattedEndDate;
    }else{
      
        queryParams.startDate = formattedStartDate;
        queryParams.endDate = formattedEndDate;

    }
    


   let queryParamsBucket={}
   if (selectedName === "Grand Total") {
    queryParamsBucket.bucketwise = null;
} else {
  queryParamsBucket.bucketwise = selectedName;
}


let queryParamsLaon={}
  if(loanid){
    queryParamsLaon.loanid=loanid
   }

    axiosInstance.get ('/analytics/collection-performance-loans',{
      headers: {
      },
      params: {startDate:queryParams.startDate,endDate:queryParams.endDate,bucketwise:queryParamsBucket.bucketwise,loanid:queryParamsLaon.loanid}
   
    })
    .then((res) => {   
      setInfoData(res?.data?.emiDetails)
    })
    .catch((error) => {
    });

    
   }

 const  fetchingBucketData =()=>{
  setTableVisible(true); 
  const startDateFrom = moment().startOf('month');
  const endDateTo = moment();

  // Format the dates to the desired format
  const formattedStartDate = startDateFrom.format('YYYY-MM-DD');
  const formattedEndDate = endDateTo.format('YYYY-MM-DD');

  let queryParams = {};

  if(startDate && endDate){
    const formattedStartDate = moment(startDate, 'DD MMM YYYY').format('YYYY-MM-DD');
    const formattedEndDate = moment(endDate, 'DD MMM YYYY').format('YYYY-MM-DD');

  queryParams.startDate = formattedStartDate;
  queryParams.endDate = formattedEndDate;
  }else{
    if (formattedStartDate && formattedEndDate) {
      queryParams.startDate = formattedStartDate;
      queryParams.endDate = formattedEndDate;
    }
  }
  


 let queryParamsBucket={}
 if (selectedName === "Grand Total") {
  queryParamsBucket.bucketwise = null;
} else {
queryParamsBucket.bucketwise = selectedName;
}


let queryParamsLoan={}
if(loanid){
  queryParamsLoan.loanid=loanid
  setTableVisible(true)
 }
 if(bucketStatus){
  queryParamsLoan.Status=bucketStatus
 }

  axiosInstance.get ('/analytics/collection-performance-loans',{
    headers: {
    },
    params: {startDate:queryParams.startDate,endDate:queryParams.endDate,bucketwise:queryParamsBucket.bucketwise,loanid:queryParamsLoan.loanid,Status:queryParamsLoan.Status}
 
  })
  .then((res) => {   
    if(res?.data?.emiDetails.length>0){
      setInfoData(res?.data?.emiDetails)
    }else {
      clearFilter();
      window.alert('Loan ID not in table');
  }
   
  })
  .catch((error) => {
  });


 }
 


  const handleLoanProfile = (loan_id,loanId)=>{
         dispatch({ type: 'SET_LOAN_CONTEXT', payload: { loanid: loan_id, legacyLoanId: loanId } });
         const urlUsers = `/loan-repayment/profile?loanId=${loan_id}`;
         const callDetailsUrl = `/call-history/details?loanId=${loan_id}`;
         const urlGetReminder=`/call-history/reminder-details?loanId=${loan_id}`
         const emihistoryUrl=`/emis/for-loan?loanId=${loan_id}`

         dispatch(userActions.fetchCallDetails(callDetailsUrl, user),[])
         dispatch(userActions.fetchLoanDetails(urlUsers, user),[])
         dispatch(userActions.getReminder(urlGetReminder))
         dispatch(userActions.getEmiHistory(emihistoryUrl,user))


     window.open(`/Loanprofile?loanId=${loan_id}&legacyLoanId=${loanId}`, "_blank");  }

   function formatNumberWithCommas(number) {
    return number?.toLocaleString('en-IN'); 
  }


  const handleDownloadList=()=>{
    const currentDate = new Date();
    const day = String(currentDate.getDate()).padStart(2, '0');
    const month = String(currentDate.getMonth() + 1).padStart(2, '0');
    const year = String(currentDate.getFullYear());
    const formattedDate = `${day}-${month}-${year}`;
    document.getElementById("downloadButton").disabled=true;
    document.getElementById("downloadButton").innerText="Wait....";
    document.getElementById("downloadButton").style.backgroundColor="#D22129";
    document.getElementById("downloadButton").style.color= "white";
    document.getElementById("downloadButton").style.fontFamily= "Inter-Medium";
    document.getElementById("downloadButton").style.fontSize= "15px";
    document.getElementById("downloadButton").style.width= "130px";
    document.getElementById("downloadButton").style.cursor= "pointer";
    document.getElementById("downloadButton").style.height= "34px";
    document.getElementById("downloadButton").style.borderRadius= "5px";
    document.getElementById("downloadButton").style.textAlign= "center";
    // document.getElementById("downloadButton").style.marginLeft="150px";
    document.getElementById("downloadButton").style.backgroundImage = "none"


    
    const startDateFrom = moment().startOf('month');
    const endDateTo = moment();
  
    // Format the dates to the desired format
    const formattedStartDate = startDateFrom.format('YYYY-MM-DD');
    const formattedEndDate = endDateTo.format('YYYY-MM-DD');
  
    let queryParams = {};
  
    if(startDate && endDate){
      const formattedStartDate = moment(startDate, 'DD MMM YYYY').format('YYYY-MM-DD');
      const formattedEndDate = moment(endDate, 'DD MMM YYYY').format('YYYY-MM-DD') ;
  
    queryParams.startDate = formattedStartDate;
    queryParams.endDate = formattedEndDate;
    }else{
      if (formattedStartDate && formattedEndDate) {
        queryParams.startDate = formattedStartDate;
        queryParams.endDate = formattedEndDate;
      }
    }
    
     


    if (productTypeSelected && productTypeSelected !== "all") {
      queryParams.loanType = Number(productTypeSelected);
    }
    axiosInstance.get("/excel/OneMonthOverdue", {
      params: queryParams,
      responseType: 'arraybuffer',
      headers: {
      }
  }).then((res)=>{
    setTimeout(() => {
      document.getElementById("downloadButton").disabled=false
      document.getElementById("downloadButton").innerText="Export";
      document.getElementById("downloadButton").style.paddingLeft = "30px";
      document.getElementById("downloadButton").style.backgroundColor="#D22129";
      document.getElementById("downloadButton").style.color= "white";
      document.getElementById("downloadButton").style.fontFamily= "Inter-Medium";
      document.getElementById("downloadButton").style.fontSize= "15px";
      document.getElementById("downloadButton").style.width= "130px";
      document.getElementById("downloadButton").style.cursor= "pointer";
      document.getElementById("downloadButton").style.height= "34px";
      document.getElementById("downloadButton").style.borderRadius= "5px";
      document.getElementById("downloadButton").style.textAlign= "center";
      // document.getElementById("downloadButton").style.marginLeft= "30px";
      document.getElementById("downloadButton").style.backgroundImage = `url(${download})`
      document.getElementById("downloadButton").style.backgroundRepeat  ='no-repeat' 
      // document.getElementById("downloadButton").style.backgroundPositionY  ='20px' 
      document.getElementById("downloadButton").style.backgroundSize  ='15px' 
      document.getElementById("downloadButton").style.backgroundPosition  ='10px 10px'

    }, 2000);
    const blob = new Blob([res.data], { type: "application/xlsx", });
    const url= window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href =url
    link.download = `${formattedDate}.xlsx`;

    document.body.appendChild(link);

    link.click();

    document.body.removeChild(link);
  }
    
  ).catch((error)=>{
    alert("Error Downloading")
    document.getElementById("downloadButton").innerText="Error..";
    document.getElementById("downloadButton").style.backgroundColor="#D22129";
    document.getElementById("downloadButton").disabled=false
      document.getElementById("downloadButton").style.paddingLeft = "30px";
      document.getElementById("downloadButton").style.backgroundColor="#D22129";
      document.getElementById("downloadButton").style.color= "white";
      document.getElementById("downloadButton").style.fontFamily= "Inter-Medium";
      document.getElementById("downloadButton").style.fontSize= "15px";
      document.getElementById("downloadButton").style.width= "130px";
      document.getElementById("downloadButton").style.cursor= "pointer";
      document.getElementById("downloadButton").style.height= "34px";
      document.getElementById("downloadButton").style.borderRadius= "5px";
      document.getElementById("downloadButton").style.textAlign= "center";
      // document.getElementById("downloadButton").style.marginLeft= "30px";
      document.getElementById("downloadButton").style.backgroundImage = `url(${download})`
      document.getElementById("downloadButton").style.backgroundRepeat  ='no-repeat' 
      // document.getElementById("downloadButton").style.backgroundPositionY  ='20px' 
      document.getElementById("downloadButton").style.backgroundSize  ='15px' 
      document.getElementById("downloadButton").style.backgroundPosition  ='10px 10px'
    setTimeout(() => {
      document.getElementById("downloadButton").disabled=false
      document.getElementById("downloadButton").innerText="Export";
      // document.getElementById("downloadButton").style.paddingLeft = "30px";
      document.getElementById("downloadButton").style.backgroundColor="#D22129";
      document.getElementById("downloadButton").style.color= "white";
      document.getElementById("downloadButton").style.fontFamily= "Inter-Medium";
      document.getElementById("downloadButton").style.fontSize= "15px";
      document.getElementById("downloadButton").style.width= "130px";
      document.getElementById("downloadButton").style.cursor= "pointer";
      document.getElementById("downloadButton").style.height= "34px";
      document.getElementById("downloadButton").style.borderRadius= "5px";
      document.getElementById("downloadButton").style.textAlign= "center";
      // document.getElementById("downloadButton").style.marginLeft= "30px";
      document.getElementById("downloadButton").style.backgroundImage = `url(${download})`
      document.getElementById("downloadButton").style.backgroundRepeat  ='no-repeat' 
      // document.getElementById("downloadButton").style.backgroundPositionY  ='20px' 
      document.getElementById("downloadButton").style.backgroundSize  ='20px' 
      document.getElementById("downloadButton").style.backgroundPosition  ='15px 10px'
    }, 1000);
  })
  } 

  
  const handleDownloadCollectionList=()=>{
    const currentDate = new Date();
    const day = String(currentDate.getDate()).padStart(2, '0');
    const month = String(currentDate.getMonth() + 1).padStart(2, '0');
    const year = String(currentDate.getFullYear());
    const formattedDate = `${day}-${month}-${year}`;
    document.getElementById("downloadButton").disabled=true;
    document.getElementById("downloadButton").innerText="Wait....";
    document.getElementById("downloadButton").style.backgroundColor="#D22129";
    document.getElementById("downloadButton").style.color= "white";
    document.getElementById("downloadButton").style.fontFamily= "Inter-Medium";
    document.getElementById("downloadButton").style.fontSize= "15px";
    document.getElementById("downloadButton").style.width= "130px";
    document.getElementById("downloadButton").style.cursor= "pointer";
    document.getElementById("downloadButton").style.height= "34px";
    document.getElementById("downloadButton").style.borderRadius= "5px";
    document.getElementById("downloadButton").style.textAlign= "center";
    // document.getElementById("downloadButton").style.marginLeft="150px";
    document.getElementById("downloadButton").style.backgroundImage = "none"



    const startDateFrom = moment().startOf('month');
    const endDateTo = moment();
  
    // Format the dates to the desired format
    const formattedStartDate = startDateFrom.format('YYYY-MM-DD');
    const formattedEndDate = endDateTo.format('YYYY-MM-DD');
  
    let queryParams = {};
  
    if(startDate && endDate){
      const formattedStartDate = moment(startDate, 'DD MMM YYYY').format('YYYY-MM-DD');
      const formattedEndDate = moment(endDate, 'DD MMM YYYY').format('YYYY-MM-DD') ;
  
    queryParams.startDate = formattedStartDate;
    queryParams.endDate = formattedEndDate;
    }else{
      if (formattedStartDate && formattedEndDate) {
        queryParams.startDate = formattedStartDate;
        queryParams.endDate = formattedEndDate;
      }
    }
    
  
  
   let queryParamsBucket={}
   if (selectedName === "Grand Total") {
    queryParamsBucket.bucketwise = null;
  } else {
  queryParamsBucket.bucketwise = selectedName;
  }
  
  
  let queryParamsLoan={}
  if(loanid){
    queryParamsLoan.loanid=loanid
   }
   if(bucketStatus){
    queryParamsLoan.Status=bucketStatus
   }
      
    axiosInstance.get("/excel/AllCollectionloans", {
      params: {
        startDate: queryParams.startDate, endDate: queryParams.endDate, bucketwise: queryParamsBucket.bucketwise, loanid: queryParamsLoan.loanid, Status: queryParamsLoan.Status, loanType:
          productTypeSelected && productTypeSelected !== "all"
            ? Number(productTypeSelected)
            : undefined
},
      responseType: 'arraybuffer',
      headers: {
      }
  }).then((res)=>{
    setTimeout(() => {
      document.getElementById("downloadButton").disabled=false
      document.getElementById("downloadButton").innerText="Export";
      document.getElementById("downloadButton").style.paddingLeft = "30px";
      document.getElementById("downloadButton").style.backgroundColor="#D22129";
      document.getElementById("downloadButton").style.color= "white";
      document.getElementById("downloadButton").style.fontFamily= "Inter-Medium";
      document.getElementById("downloadButton").style.fontSize= "15px";
      document.getElementById("downloadButton").style.width= "130px";
      document.getElementById("downloadButton").style.cursor= "pointer";
      document.getElementById("downloadButton").style.height= "34px";
      document.getElementById("downloadButton").style.borderRadius= "5px";
      document.getElementById("downloadButton").style.textAlign= "center";
      // document.getElementById("downloadButton").style.marginLeft= "30px";
      document.getElementById("downloadButton").style.backgroundImage = `url(${download})`
      document.getElementById("downloadButton").style.backgroundRepeat  ='no-repeat' 
      // document.getElementById("downloadButton").style.backgroundPositionY  ='20px' 
      document.getElementById("downloadButton").style.backgroundSize  ='15px' 
      document.getElementById("downloadButton").style.backgroundPosition  ='10px 10px'

    }, 2000);
    const blob = new Blob([res.data], { type: "application/xlsx", });
    const url= window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href =url
    link.download = `${formattedDate}.xlsx`;

    document.body.appendChild(link);

    link.click();

    document.body.removeChild(link);
  }
    
  ).catch((error)=>{
    alert("Error Downloading")
    document.getElementById("downloadButton").innerText="Error..";
    document.getElementById("downloadButton").style.backgroundColor="#D22129";
    document.getElementById("downloadButton").disabled=false
      document.getElementById("downloadButton").style.paddingLeft = "30px";
      document.getElementById("downloadButton").style.backgroundColor="#D22129";
      document.getElementById("downloadButton").style.color= "white";
      document.getElementById("downloadButton").style.fontFamily= "Inter-Medium";
      document.getElementById("downloadButton").style.fontSize= "15px";
      document.getElementById("downloadButton").style.width= "130px";
      document.getElementById("downloadButton").style.cursor= "pointer";
      document.getElementById("downloadButton").style.height= "34px";
      document.getElementById("downloadButton").style.borderRadius= "5px";
      document.getElementById("downloadButton").style.textAlign= "center";
      // document.getElementById("downloadButton").style.marginLeft= "30px";
      document.getElementById("downloadButton").style.backgroundImage = `url(${download})`
      document.getElementById("downloadButton").style.backgroundRepeat  ='no-repeat' 
      // document.getElementById("downloadButton").style.backgroundPositionY  ='20px' 
      document.getElementById("downloadButton").style.backgroundSize  ='15px' 
      document.getElementById("downloadButton").style.backgroundPosition  ='10px 10px'
    setTimeout(() => {
      document.getElementById("downloadButton").disabled=false
      document.getElementById("downloadButton").innerText="Export";
      // document.getElementById("downloadButton").style.paddingLeft = "30px";
      document.getElementById("downloadButton").style.backgroundColor="#D22129";
      document.getElementById("downloadButton").style.color= "white";
      document.getElementById("downloadButton").style.fontFamily= "Inter-Medium";
      document.getElementById("downloadButton").style.fontSize= "15px";
      document.getElementById("downloadButton").style.width= "130px";
      document.getElementById("downloadButton").style.cursor= "pointer";
      document.getElementById("downloadButton").style.height= "34px";
      document.getElementById("downloadButton").style.borderRadius= "5px";
      document.getElementById("downloadButton").style.textAlign= "center";
      // document.getElementById("downloadButton").style.marginLeft= "30px";
      document.getElementById("downloadButton").style.backgroundImage = `url(${download})`
      document.getElementById("downloadButton").style.backgroundRepeat  ='no-repeat' 
      // document.getElementById("downloadButton").style.backgroundPositionY  ='20px' 
      document.getElementById("downloadButton").style.backgroundSize  ='20px' 
      document.getElementById("downloadButton").style.backgroundPosition  ='15px 10px'
    }, 1000);
  })
  }


  const DownnloadMIPExcel=()=>{
    const currentDate = new Date();
    const day = String(currentDate.getDate()).padStart(2, '0');
    const month = String(currentDate.getMonth() + 1).padStart(2, '0');
    const year = String(currentDate.getFullYear());
    const formattedDate = `${day}-${month}-${year}`;
     
    axiosInstance.get("/excel/allMIP", {
      params: {
        loanType:
          productTypeSelected && productTypeSelected !== "all"
            ? Number(productTypeSelected)
            : undefined
      },
      responseType: 'arraybuffer',
      headers: {
      }
  }).then((res)=>{
    setTimeout(() => {
    
    }, 2000);
    const blob = new Blob([res.data], { type: "application/xlsx", });
    const url= window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href =url
    link.download = `${formattedDate}.xlsx`;

    document.body.appendChild(link);

    link.click();

    document.body.removeChild(link);
  }
    
  ).catch((error)=>{
   
  })
  } 

  const [rowsPerPage, setRowsPerPage] = useState(50); // Default: 10 rows per page
  const [page, setPage] = useState(0); // Current page index

  // Handle row change (including "All" option)
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(event.target.value === "-1" ? -1 : parseInt(event.target.value, 10));
    setPage(0); // Reset to first page when changing rows
  };

  // Handle page change
  const handleChangePage = (_, newPage) => {
    setPage(newPage);
  };

  // Paginate data (show all if rowsPerPage is -1)
  const paginatedData = rowsPerPage === -1 ? infoData : infoData.slice(page * rowsPerPage, (page + 1) * rowsPerPage); 

  useEffect(() => {
    setPage(0);
  }, [infoData]); 

  return (
    
    <div style={{width:"100%",backgroundColor:'white',minHeight:'100vh'}}>
    <p style={{textAlign:"center",fontFamily:'Inter-Medium',color:'#667085',fontSize:'25px'}}>CollectionPerformance </p>

   


    <div style={{ display: 'flex' }}> 
     
              <div style={{ height:'30px',width:'15em', borderRadius: '20px',marginRight:"60px",marginTop:'-2px'}}>
              <DatePicker
                value={startDate && endDate ? [startDate, endDate] : null}
                style={{ height:'33px', BorderRadius: '5px',padding: '2px', backgroundRepeat: 'no-repeat',
                backgroundPosition: '5px center',
                backgroundSize: '15px 15px', backgroundImage: `url(${calender})`, paddingLeft: '30px',fontSize:"14px",fontWeight:"normal", border:'1px solid #ccc'}}
                placeholder="Select date range"
                allowClear={true}
                format="DD MMM YYYY"
                onChange={(dates, dateStrings) => {
                  setStartDateFrom(dateStrings?.validatedValue[0])
                  setEndDateTo(dateStrings?.validatedValue[1])
              }}
                range
                />
                </div>
               
                <div > 
           <button style={{display: 'flex', alignItems: 'center',width:'130px',backgroundColor:'#D22129',height:'34px',borderStyle:'none',borderRadius:"5px",color:'white',fontFamily:"Inter-Medium",paddingLeft:'10px'}}
             onClick={() => fetchingData()}
             >
               Search Results
             </button>
             </div>
         
             <div style={{marginLeft:'40px'}}>
             <div style={{backgroundColor:'#D22129',display: 'flex', alignItems: 'center',width:'130px',height:'34px',borderStyle:'none',borderRadius:"5px",fontFamily:"Inter-Medium",paddingLeft:'10px',justifyContent:'space-around',cursor:'pointer',marginRight:'20px'}}
               id="downloadButton"   onClick={() => handleDownloadList()} >
             
         <img src={download} style={{height:'20px',marginLeft:'8px'}} alt=""/> 
         <span style={{fontFamily:"Inter-Medium",color:'white',paddingRight:"15px"}}>Export</span>
        
          </div>  
                
          </div>
          <div>
              <span
                   onClick={() => {
                    DownnloadMIPExcel();
                  }}
                className="customerDashboardButton"
                style={{fontSize:'20px', letterSpacing: '2px',
                  margin: "0px",
                }}
              >
                [ MIP={MipData} ]
              </span>   
              </div>

        
           <button style={{display: 'flex', alignItems: 'center',width:'120px',backgroundColor:'#D22129',height:'34px',borderStyle:'none',borderRadius:"5px",color:'white',fontFamily:"Inter-Medium",paddingLeft:'15px',marginLeft:'20px'}}
             onClick={() => clearFilter()}
             >
               Clear Filter
             </button>
       
            
     </div>
    
    
        <table className='tables' style={{marginRight:'10px'}}>
          <thead className='table-heading'>
            <tr>
              <th style={{ fontSize: '14px', cursor: 'pointer', width: '8px%', fontFamily: "Inter-Medium", paddingLeft: '10px' }}>Buckets</th>
              <th style={{ fontSize: '14px', cursor: 'pointer', width: '10px%', fontFamily: "Inter-Medium" }}>Overdue</th>
              <th style={{ fontSize: '14px', cursor: 'pointer', width: '10px%', fontFamily: "Inter-Medium" }}>Collected</th>
              <th style={{ fontSize: '14px', cursor: 'pointer', width: '15px%', fontFamily: "Inter-Medium" }}>Total count</th>
              <th style={{ fontSize: '14px', cursor: 'pointer', width: '10px%', fontFamily: "Inter-Medium" }}>Collected Amt</th>
              <th style={{ fontSize: '14px', cursor: 'pointer', width: '10px%', fontFamily: "Inter-Medium" }}>Total Amt</th>
              <th style={{ fontSize: '14px', cursor: 'pointer', width: '10px%', fontFamily: "Inter-Medium" }}>Percentage</th>
            </tr>
          </thead>
          
          <tbody className='table-body'>
            {startDate && endDate ?
            TableData?.map((item, index) => (
              <tr className="table-row" key={index} style={{ lineHeight:"25px",backgroundColor: selectedName === item.bucket ? "#f0f8ff" : "white",cursor: "pointer"}}
              onClick={() =>{ tableBucketClicked(item.bucket);
                setSelectedName(item.bucket,'bucket')}}
              
              >
                <td style={{ fontSize: '14px', cursor: 'pointer', width: '10em', fontFamily: "Inter-Medium", color: '#667085', paddingLeft: '10px' }}>{item.bucket}</td>
                <td style={{ fontSize: '14px', cursor: 'pointer', width: '10em', fontFamily: "Inter-Medium", color: '#667085' }}>{item.Ovd_count}</td>
                <td style={{ fontSize: '14px', cursor: 'pointer', width: '10em', fontFamily: "Inter-Medium", color: '#667085' }}>{item.collected}</td>
                <td style={{ fontSize: '14px', cursor: 'pointer', width: '10em', fontFamily: "Inter-Medium", color: '#667085' }}>{item.Total_count}</td>
                <td style={{ fontSize: '14px', cursor: 'pointer', width: '10em', fontFamily: "Inter-Medium", color: '#667085' }}>₹{formatNumberWithCommas(Math.round(item.Collected_amt))}</td>
                <td style={{ fontSize: '14px', cursor: 'pointer', width: '10em', fontFamily: "Inter-Medium", color: '#667085' }}>₹{formatNumberWithCommas(Math.round(item.Total_amt))}</td>
                <td style={{ fontSize: '14px', cursor: 'pointer', width: '10em', fontFamily: "Inter-Medium", color: '#667085' }}>  {`${((item.Collected_amt / (item.Total_amt)) * 100).toFixed(2)}%`?`${((item.Collected_amt / (item.Total_amt)) * 100).toFixed(2)}%`:'-'}</td>
              </tr>
            )):
            data?.map((item, index) => (
              <tr className="table-row" key={index} style={{ lineHeight:"25px",backgroundColor: selectedName === item.bucket ? "#f0f8ff" : "white",cursor: "pointer"}}
              onClick={() =>{ 
                tableBucketClicked(item.bucket);
                setSelectedName(item.bucket,'bucket')}} >
                <td style={{ fontSize: '14px', cursor: 'pointer', width: '10em', fontFamily: "Inter-Medium", color: '#667085', paddingLeft: '10px' }}>{item.bucket}</td>
                <td style={{ fontSize: '14px', cursor: 'pointer', width: '10em', fontFamily: "Inter-Medium", color: '#667085' }}>{item.Ovd_count}</td>
                <td style={{ fontSize: '14px', cursor: 'pointer', width: '10em', fontFamily: "Inter-Medium", color: '#667085' }}>{item.collected}</td>
                <td style={{ fontSize: '14px', cursor: 'pointer', width: '10em', fontFamily: "Inter-Medium", color: '#667085' }}>{item.Total_count}</td>
                <td style={{ fontSize: '14px', cursor: 'pointer', width: '10em', fontFamily: "Inter-Medium", color: '#667085' }}> ₹{formatNumberWithCommas(Math.round(item.Collected_amt))}</td>
                <td style={{ fontSize: '14px', cursor: 'pointer', width: '10em', fontFamily: "Inter-Medium", color: '#667085' }}>₹{formatNumberWithCommas(Math.round(item.Total_amt))}</td>                
                <td style={{ fontSize: '14px', cursor: 'pointer', width: '10em', fontFamily: "Inter-Medium", color: '#667085' }}>   {`${((item.Collected_amt / (item.Total_amt)) * 100).toFixed(2)}%`?`${((item.Collected_amt / (item.Total_amt)) * 100).toFixed(2)}%`:'-'}</td>
              </tr> 
            ))}
          </tbody>
        </table>

        {/* AI Collection Optimizer - between bucket table and loan table */}
        <AiCollectionOptimizer loanData={infoData} />

   { tableVisible && infoData.length > 0 && (
        <div style={{ display: 'flex' }} > 
        <Input 
        value={loanid || ""}
        onChange={(event) => {
          setLoanid(event.target.value);
          // if (event.target.value === '') {
          //   setEmiamount("")
          //   clearDateFilter(); 
          // }
        }} 
        type="text"
        placeholder="Loanid"
        className="placeholder-style"
        style={{fontSize: '14px',paddingLeft: '25px',marginLeft:'5px',width:'15%',fontFamily: 'Inter-Medium',backgroundImage: `url(${search})`,backgroundRepeat: 'no-repeat',backgroundPosition: '5px center',backgroundSize: '15px 15px',paddingRight: '5px', borderColor:'#cccccc',borderStyle:'solid',borderRadius:"8px",borderWidth:'1px',height:'35px',marginTop:'30px'
        }}
      />

     <Input type="select" id="page"  style={{color:'#667085',fontSize:'14px',fontFamily:'Inter-Medium',width:'15%',marginTop:'30px',marginLeft:'20px'}} onChange={(event)=>setBucketStatus(event.target.value)}>
    <option value="" >Select Status</option>
    <option value="ovdPaid">ovdPaid</option>
    <option value="Overdue">Overdue</option>
    
       </Input>

          
           <button style={{display: 'flex', alignItems: 'center',width:'130px',backgroundColor:'#D22129',height:'34px',borderStyle:'none',borderRadius:"5px",color:'white',fontFamily:"Inter-Medium",paddingLeft:'10px',marginTop:'30px',marginLeft:'20px'}}
             onClick={() => fetchingBucketData()}
             >
               Search Results
             </button>


                <div style={{backgroundColor:'#D22129',display: 'flex', alignItems: 'center',width:'130px',height:'34px',borderStyle:'none',borderRadius:"5px",fontFamily:"Inter-Medium",paddingLeft:'10px',justifyContent:'space-around',cursor:'pointer',marginLeft:'20px',marginTop:'30px'}}
               id="downloadButton"   onClick={() => handleDownloadCollectionList()} >
             
         <img src={download} style={{height:'20px',marginLeft:'8px'}} alt=""/> 
         <span style={{fontFamily:"Inter-Medium",color:'white',paddingRight:"15px"}}>Export</span>
        
                </div>  
       </div>
          )}
       
       {tableVisible && infoData.length > 0 &&(
        <div style={{marginTop:'30px'}}>
      <table className='tables'>
      <thead className='table-heading' >
            <tr>
              <th style={{ fontSize: '14px', cursor: 'pointer', width: '8px%', fontFamily: "Inter-Medium", paddingLeft: '10px' }}>LoanId</th>
              <th style={{ fontSize: '14px', cursor: 'pointer', width: '10px%', fontFamily: "Inter-Medium",paddingLeft: '10px' }}>Buckets</th>
              <th style={{ fontSize: '14px', cursor: 'pointer', width: '7px%', fontFamily: "Inter-Medium" }}>DPD'S</th>
              <th style={{ fontSize: '14px', cursor: 'pointer', width: '15px%', fontFamily: "Inter-Medium" ,paddingLeft: '10px' }}>Emi amount</th>
              <th style={{ fontSize: '14px', cursor: 'pointer', width: '10px%', fontFamily: "Inter-Medium" ,paddingLeft: '10px' }}>Collected_amt</th>
              <th style={{ fontSize: '14px', cursor: 'pointer', width: '10px%', fontFamily: "Inter-Medium",paddingLeft: '10px'  }}>Due date</th>
              <th style={{ fontSize: '14px', cursor: 'pointer', width: '10px%', fontFamily: "Inter-Medium" ,paddingLeft: '10px' }}>Paid date</th>
              <th style={{ fontSize: '14px', cursor: 'pointer', width: '10px%', fontFamily: "Inter-Medium",paddingLeft: '10px'  }}>Status</th>
              <th style={{ fontSize: '12px', cursor: 'pointer', width: '8px%', fontFamily: "Inter-Medium", paddingLeft: '10px', background: '#dcfce7', color: '#166534' }}>Recovery Prob.</th>
              <th style={{ fontSize: '12px', cursor: 'pointer', width: '10px%', fontFamily: "Inter-Medium", paddingLeft: '10px', background: '#dcfce7', color: '#166534' }}>AI Strategy</th>
              <th style={{ fontSize: '0.8vw', cursor: 'pointer', width: '9px%', fontFamily: "Inter-Medium",paddingLeft: '10px'  }}>Last / Max paid Bucket</th>
            </tr>
          </thead>
        <tbody className="table-body">
          {paginatedData?.map((item, index) => (
             <tr className="table-row" key={index} style={{ lineHeight:"25px" ,cursor: "pointer"}}
      
             >
               <td 
               // onClick={() => handleLoanProfile(item.loan_id,item.loanId)} 
               style={{ fontSize: '14px', cursor: 'pointer', width: '10em', fontFamily: "Inter-Medium", color: '#667085', paddingLeft: '10px' }} onClick={() => handleLoanProfile(item.loan_id,item.loanid)}>{item.loanid}</td>
               <td style={{ fontSize: '14px', cursor: 'pointer', width: '10em', fontFamily: "Inter-Medium", color: '#667085' }}>{item.bucketwise}</td>
               <td style={{ fontSize: '14px', cursor: 'pointer', width: '7em', fontFamily: "Inter-Medium", color: '#667085' }}>{item.max_actualdays}</td>
               <td style={{ fontSize: '14px', cursor: 'pointer', width: '10em', fontFamily: "Inter-Medium", color: '#667085' }}>₹{formatNumberWithCommas(Math.round(item.sumemiamount))}</td>
               <td style={{ fontSize: '14px', cursor: 'pointer', width: '10em', fontFamily: "Inter-Medium", color: '#667085' }}>₹{formatNumberWithCommas(Math.round(item.actualpaid_amount))}</td>
               <td style={{ fontSize: '14px', cursor: 'pointer', width: '10em', fontFamily: "Inter-Medium", color: '#667085' }}>{item.due_date?item.due_date:'-'}</td>
               <td style={{ fontSize: '14px', cursor: 'pointer', width: '10em', fontFamily: "Inter-Medium", color: '#667085' }}>{item.repaid_emidate?item.repaid_emidate:'-'}</td>
               <td style={{ fontSize: '14px', cursor: 'pointer', width: '10em', fontFamily: "Inter-Medium", color: '#667085' }}>{item.status}</td>
               <td style={{ fontSize: '11px', cursor: 'pointer', width: '7em', fontFamily: "Inter-Medium", paddingLeft: '10px', background: '#f0fdf4' }}>
                 {item.recoveryScore ? (
                   <span style={{ padding: '3px 8px', borderRadius: '10px', fontSize: '10px', fontWeight: 600, background: item.recoveryScore > 70 ? '#dcfce7' : item.recoveryScore > 40 ? '#fef3c7' : '#fee2e2', color: item.recoveryScore > 70 ? '#166534' : item.recoveryScore > 40 ? '#92400e' : '#991b1b' }}>{item.recoveryScore}%</span>
                 ) : <span style={{ color: '#9ca3af' }}>—</span>}
               </td>
               <td style={{ fontSize: '10px', cursor: 'pointer', width: '9em', fontFamily: "Inter-Medium", paddingLeft: '10px', background: '#f0fdf4', color: '#374151', lineHeight: '1.4' }}>
                 {item.aiStrategy ? (
                   <><span style={{ color: '#7c3aed', fontWeight: 600 }}>{item.aiStrategy}</span><br/><span style={{ color: '#059669', fontSize: '9px' }}>{item.aiBestTime || ''}</span></>
                 ) : <span style={{ color: '#9ca3af' }}>—</span>}
               </td>
               <td style={{ fontSize: '0.8vw', cursor: 'pointer', width: '8em', fontFamily: "Inter-Medium", color: '#667085' }}> {item.lastBucket ? item.lastBucket:'-'}{item.lastBucket || item.highestReached ? ' / ' : ''}{item.highestReached ?item.highestReached: '-'}</td>
             </tr>
          ))}
        </tbody>
      </table>

      {/* Pagination Controls */}
   
      {infoData.length > 0 && (
        <div style={{  display: 'flex',
          justifyContent: 'center', // Centers horizontally
          marginBottom: '15px' // Adds space below the pagination component
          }}>
             <TablePagination
             rowsPerPageOptions={[50, { value: -1, label: "All" }]} // Only 50 and All
             component="div"
             count={infoData.length}
             rowsPerPage={rowsPerPage}
             page={page}
             onPageChange={handleChangePage}
             onRowsPerPageChange={handleChangeRowsPerPage}
             sx={{
              "& .MuiTablePagination-select": { marginBottom: "10px" },
              "& .MuiIconButton-root": {
                marginBottom: '10px' /* Adjust the bottom margin */
              }
            }}
           />
          </div>
          )}
         
    </div>
         )}

</div>
  )
}
